<script>
import { apiOrganRoleAppPermissionCommit, apiOrganRoleAppUnbindList, apiOrganRolePermissionTree } from '@/api/enterprise'
import UmTableRole from '@/components/UmTableRole'
import _ from 'lodash'
export default {
  name: 'AddApplication',
  components: { UmTableRole },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    roleUuid: {
      type: String,
      default: ''
    },
    roleName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      keywords: '',
      loading: false,
      step: 1,
      selected: [],
      tableData: [],
      originData: [],
      roleModuleTree: [],
      moduleCodeList: [],
      moduleDataList: []
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
      }
    },
    isEmpty() {
      return this.moduleDataList.length === 0 && this.loading !== true
    }
  },
  watch: {
    visible: {
      handler(show) {
        if (show) {
          this.getApplication()
        }
      }
    }
  },
  created() {},
  methods: {
    closeDialog() {
      this.step = 1
      this.moduleCodeList = []
      this.$refs.authTable.clearSelection()
    },
    inputKeywords(key) {
      if (key) {
        this.tableData = this.originData.filter(i => i.appName.indexOf(key) > -1)
      } else {
        this.tableData = _.cloneDeep(this.originData)
      }
    },
    async getApplication() {
      // 获取应用列表
      try {
        this.loading = true
        const res = await apiOrganRoleAppUnbindList({ roleUuid: this.roleUuid })
        this.tableData = res.data
        this.originData = _.cloneDeep(res.data)
      } catch (e) {

      } finally {
        this.loading = false
      }
    },
    selectApplication(val) {
      // 勾选应用
      this.moduleCodeList = val.filter(i => i.moduleCode).map(i => i.moduleCode)
      this.moduleDataList = val.map(i => {
        return {
          appUuid: i.appUuid,
          appName: i.appName,
          moduleCode: i.moduleCode,
          moduleCodeList: [],
          roleData: []
        }
      })
    },
    changeAuthData(codes, index) {
      this.moduleDataList[index].moduleCodeList = codes
    },
    async getAppRoleTree() {
      // 获取应用权限树
      try {
        this.loading = true
        if (this.moduleCodeList.length === 0) return
        const res = await apiOrganRolePermissionTree({
          roleUuid: this.roleUuid,
          moduleCodeList: this.moduleCodeList
        })
        this.roleModuleTree = res.data
        this.moduleDataList.forEach((item) => {
          const roleData = res.data.find(i => i.sysModuleCode === item.moduleCode)
          if (roleData) {
            item.roleData = [roleData]
          }
        })
      } catch (e) {

      } finally {
        this.loading = false
      }
    },
    setStep(step) {
      if (step === 1) {
        // 选择应用
      }
      if (step === 2) {
        // 配置应用权限
        if (Array.isArray(this.moduleDataList) && this.moduleDataList.length) {
          this.getAppRoleTree()
        } else {
          this.$message.error('请选择应用')
          return
        }
      }
      this.step = step
    },
    async saveAuth() {
      try {
        this.loading = true
        const appPermissionList = this.moduleDataList.map((item) => {
          return {
            appUuid: item.appUuid,
            moduleCode: item.moduleCode,
            moduleCodeList: this.$refs[item.appUuid][0].getCheckData()
          }
        })
        await apiOrganRoleAppPermissionCommit({
          roleUuid: this.roleUuid,
          appPermissionList
        })
        this.$message.success('操作成功')
        this.visible = false
        this.$emit('submit')
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <el-dialog
    title="添加应用"
    :visible.sync="visible"
    width="80%"
    append-to-body
    destroy-on-close
    @close="closeDialog"
  >
    <div v-loading="loading" class="auth-dialog">
      <div class="auth-dialog-head f-mg-b15">
        <div class="auth-dialog-head-item" :class="[step === 1 ? 'active':'']">第一步：选择应用</div>
        <div class="auth-dialog-head-item" :class="[step === 2 ? 'active':'']">第二步：配置权限</div>
      </div>
      <div class="auth-role-name f-mg-b15">所选角色：{{ roleName }}</div>
      <el-form v-show="step === 1" label-position="left" label-width="80px">
        <el-form-item label="应用名称">
          <el-input v-model="keywords" clearable placeholder="请输入应用名称" style="width: 240px" @input="inputKeywords" />
        </el-form-item>
      </el-form>
      <el-table v-show="step === 1" ref="authTable" :data="tableData" height="500px" @selection-change="selectApplication">
        <el-table-column type="selection" width="70" />
        <el-table-column label="应用名称" min-width="120" prop="appName" />
        <el-table-column label="应用描述" min-width="150" prop="appDescription" />
      </el-table>
      <div v-show="step === 2" class="auth-role-table">
        <template v-for="(item,index) in moduleDataList">
          <um-table-role
            :ref="item.appUuid"
            :key="item.appUuid"
            :tree-data="item.roleData"
            :table-name="item.appName"
            show-head
            @change="(codes)=> changeAuthData(codes,index)"
          />
        </template>
        <um-empty v-if="isEmpty" description="未查询到应用权限" />
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="step === 2" type="primary" @click="setStep(1)">上一步</el-button>
      <el-button @click="visible = false">取 消</el-button>
      <el-button v-if="step === 1" type="primary" @click="setStep(2)">下一步</el-button>
      <el-button v-else type="primary" :loading="loading" :disabled="loading" @click="saveAuth">保 存</el-button>
    </span>
  </el-dialog>
</template>

<style scoped lang="scss">
.auth-dialog{
  .auth-dialog-head{
    display: flex;
    align-items: center;
    justify-content: space-around;
    .auth-dialog-head-item{
      font-size: 16px;
      color: #31415F;
    }
    .active{
      color: #4B6CF9;
    }
  }
  .auth-role-name{
    font-size: 14px;
    color: #31415F;
  }
  .auth-role-table{
    height: 500px;
    overflow: auto;
  }
}
</style>
